<template>
    <div class="field radio field--full" :class="{ 'required': required, 'radio--checkbox': checkbox }">
        <div v-if="heading" class="heading">
            <legend>
                <span class="legend-text">{{ heading }}</span>
            </legend>
        </div>
        <input type="hidden" :value="newValue" />
        <div v-for="(option, index) in options" :key="index" class="input">
            <label>
                <input
                    v-model="newValue"
                    type="radio"
                    :value="option"
                    :checked="isChecked(option)"
                />
                <span />
                <p>{{ option }}</p>
            </label>
            <strong v-if="checkbox" class="small">OR</strong>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        heading: {
            type: String,
            default: null
        },
        value: {
            type: [String, Boolean],
            default: false,
        },
        required: {
            type: Boolean,
            default: false
        },
        checkbox: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            newValue: this.value,
        };
    },

    watch: {
        newValue() {
            this.$emit('validate');
            this.$emit('update:value', this.newValue);
        }
    },

    methods: {
        isChecked(option) {
            return this.newValue === option;
        }
    }
}
</script>
<style lang="scss" scoped>
    .input {
        label {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            &:after {
                display: none;
            }
        }

        &:last-child {
            label {
                margin: 0;
            }
        }

        span {
            border-radius: 50%;
        }

        p {
            font-weight: 500;
            text-transform: none;
        }
    }

    .radio--checkbox .input {
        display: block!important;
        cursor: pointer;

        span {
            border-radius: 0;
        }

        strong {
            margin-left: 1rem;
        }

        p {
            letter-spacing: 0;
        }
    }

    .radio--checkbox {
        margin-bottom: 20px;
    }

    .radio--checkbox .input:last-child {
        label {
            margin: 1rem;
        }

        strong {
            display: none!important;
        }
    }

</style>
